<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		value: function() {

			if (!this.item.play) return '-'
			if (!this.item.play.result) return 'Untracked'
			return this.item.play.won ? 'Win' : 'Loss'

		}

	}

}

</script>

<style scoped>

</style>
